module.exports = __webpack_public_path__ + "static/react_redux_graphql-2c4027e325e3902e332a6ac731ec578f.png";